import React from "react";

const Ricoh = () => {
  return (
    <div>
      <ol type="1">
        <h2>Ricoh Printers</h2>
        <h2>User Name: Admin Password: leave blank</h2>

        <li className="list">
          Grd Founders (Big One) \\UPHSURGPSAPP001\SURG-GFOUND-RICOH1
          170.212.71.176{" "}
        </li>

        <li className="list">
          Grd 079 Founders (Small One) \\UPHSURGPSAPP001\SURG-GFOUND-RICOH2
          170.212.71.171
        </li>

        <li className="list">
          Grd 079 Founders \\UPHSURGPSAPP001\SURG-GFOUND-RICOH3 170.212.70.42
        </li>

        <li className="list">
          3 PCAM RES ROOM \\UPHSURGPSAPP001\SURG-PCAM3URO-RICOHRES
          170.166.249.23
        </li>
        <li className="list">
          3 PCAM MEDREC office \\UPHSURGPSAPP001\SURG-PCAM3URO-RICOHMEDREC1
          170.166.250.114
        </li>
        <li className="list">
          3 PCAM \\UPHSURGPSAPP001\SURG-PCAM3URO-RICOH1 170.166.250.114
        </li>

        <li className="list">
          PCAM3 maybe by Amanda old office
          \\UPHSURGPSAPP001\SURG-PCAM3URO-RICOH2 170.166.249.23
        </li>

        <li className="list">
          4 Silver Near Deb/Dr Aarons \\UPHSURGPSAPP001\SURG-SIL4-RICOHCOLOR
          office 170.212.120.69
        </li>

        <li className="list">
          4 Silver Near VAS AA's \\UPHSURGPSAPP001\SURG-SIL4-RICOH1
          170.212.63.80
        </li>
   

        <li className="list">
          4 Maloney (GME office) \\UPHSURGPSAPP001\SURG-MAL4-RICOHEDU
          170.212.59.75
        </li>

        <li className="list">
          4 Maloney (Mervis area) \\UPHSURGPSAPP001\SURG-MAL4-RICOHRES
          170.212.59.80
        </li>

        <li className="list">
          4 Maloney ( opposite side of Fin) \\UPHSURGPSAPP001\SURG-MAL4-RICOH1
          170.212.58.46
        </li>

        <li className="list">
          4 Maloney Fitts \\UPHSURGPSAPP001\SURG-MAL4-RICOHFITTS 170.212.58.51
        </li>

        <li className="list">
          5 Maloney (Main office TRAUMA)\\UPHSURGPSAPP001\SURG-MAL5-RICOHTRA
          170.212.59.148
        </li>

        <li className="list">
          6 Silver CAR OFFICE \\UPHSURGPSAPP001\SURG-SIL6-RICOH1 170.212.63.168
        </li>

        <li className="list">
          6 White \\UPHSURGPSAPP001\SURG-WHI6-RICOH1 170.212.124.45
        </li>

        <li className="list">
          14 Spe \\UPHSURGPSAPP001\SURG-SPE14-RICOH1 10.170.55.244
        </li>

        <li className="list">
          14 spe \\UPHSURGPSAPP001\SURG-SPE14-RICOH2 10.170.55.243
        </li>

        <li className="list">
          1 Spe \\UPHSURGPSAPP001\SURG-SPE1-RICOHPLA 10.170.7.147
        </li>

        <li className="list">
          SPE10 file room EOS \\UPHSURGPSAPP001\SURG-SPE10-RICOH2 10.170.43.230
        </li>
        <li className="list">
          Rav5000 Tavr group  \\UPHSURGPSAPP001\SURG-RAV5000-RICOH2 10.172.172.105
        </li>
        <li className="list">
          Rav5000  other Ricoh \\UPHSURGPSAPP001\SURG-RAV5000-RICOH1 10.172.172.14
        </li>
        <li className="list">
          PRESBY   \\UPHSURGPSAPP001\SURG-PRESBY-RICOH1 10.179.49.215
        </li>
        <li className="list">
         SPE14 Vascular  \\UPHSURGPSAPP001\SURG-SPE14-VASRICOH 10.208.81.198
        </li>
         <li className="list">
         SPE14 Thoracic  \\UPHSURGPSAPP001\SURG-SPE14-TSURICOH 10.170.54.145
        </li>  
      </ol>
    </div>
  );
};

export default Ricoh;
